module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/hero_mob-059b76b8e9b04467a77e7032aeec0f64.jpg";